// extracted by mini-css-extract-plugin
export default {"wrapper":"GameBars_wrapper__x+NRs","vertical":"GameBars_vertical__FzU7C","horizontal":"GameBars_horizontal__byJRP"};